/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApproveCancelClaimCentralRequest } from '../models/ApproveCancelClaimCentralRequest';
import type { ApproveClaimCentralRequest } from '../models/ApproveClaimCentralRequest';
import type { ClaimCentralDTO } from '../models/ClaimCentralDTO';
import type { ClaimCentralProcessDTO } from '../models/ClaimCentralProcessDTO';
import type { ClaimDTO } from '../models/ClaimDTO';
import type { ClaimProductDataResponse } from '../models/ClaimProductDataResponse';
import type { ClaimProductHistoryResponse } from '../models/ClaimProductHistoryResponse';
import type { ClaimShippingRequest } from '../models/ClaimShippingRequest';
import type { CreateClaimImageRequest } from '../models/CreateClaimImageRequest';
import type { CreateClaimRequest } from '../models/CreateClaimRequest';
import type { CreateInvoiceRequest } from '../models/CreateInvoiceRequest';
import type { CreateNoteRequest } from '../models/CreateNoteRequest';
import type { EditClaimDetailRequest } from '../models/EditClaimDetailRequest';
import type { GetClaimCentralDetailResponse } from '../models/GetClaimCentralDetailResponse';
import type { GetClaimDashboardResponse } from '../models/GetClaimDashboardResponse';
import type { GetClaimDashboardStatResponse } from '../models/GetClaimDashboardStatResponse';
import type { GetClaimNoResponse } from '../models/GetClaimNoResponse';
import type { GetClaimStatResponse } from '../models/GetClaimStatResponse';
import type { GetPublicClaimDetailResponse } from '../models/GetPublicClaimDetailResponse';
import type { OwnerConfirmClaimRequest } from '../models/OwnerConfirmClaimRequest';
import type { PaginatedClaimDTO } from '../models/PaginatedClaimDTO';
import type { PaginatedClaimStatementDTO } from '../models/PaginatedClaimStatementDTO';
import type { PaginatedGetAllClaimCentralResponse } from '../models/PaginatedGetAllClaimCentralResponse';
import type { ReceiverConfirmClaimRequest } from '../models/ReceiverConfirmClaimRequest';
import type { TakeoutClaimRequest } from '../models/TakeoutClaimRequest';
import type { UpdateDateRequest } from '../models/UpdateDateRequest';
import type { UpdateStatusRequest } from '../models/UpdateStatusRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ClaimsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns ClaimDTO OK
     * @throws ApiError
     */
    public getClaimDetail({
        shopId,
        id,
    }: {
        shopId: string,
        id: string,
    }): CancelablePromise<ClaimDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/claims/{id}',
            path: {
                'id': id,
            },
            query: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public editClaimDetail({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: EditClaimDetailRequest,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/claims/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public takeoutClaim({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: TakeoutClaimRequest,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/claims/{id}/takeout',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateStatus({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: UpdateStatusRequest,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/claims/{id}/status',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public reopenClaim({
        id,
    }: {
        id: string,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/claims/{id}/reopen',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public receiverConfirmClaimCentral({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: ReceiverConfirmClaimRequest,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/claims/{id}/receiver-confirm',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public receiveClaimCentral({
        id,
        shopId,
    }: {
        id: string,
        shopId: string,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/claims/{id}/receive',
            path: {
                'id': id,
            },
            query: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public ownerConfirmClaimCentral({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: OwnerConfirmClaimRequest,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/claims/{id}/owner-confirm',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public cancelInvoice({
        id,
        invoiceId,
    }: {
        id: string,
        invoiceId: string,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/claims/{id}/invoice/{invoiceId}/cancel',
            path: {
                'id': id,
                'invoiceId': invoiceId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public editImportedAt({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: UpdateDateRequest,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/claims/{id}/imported',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public cancelClaim({
        id,
    }: {
        id: string,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/claims/{id}/cancel',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public cancelReceiveClaimCentral({
        id,
        shopId,
    }: {
        id: string,
        shopId: string,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/claims/{id}/cancel-receive',
            path: {
                'id': id,
            },
            query: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public approveCancelClaimCentral({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: ApproveCancelClaimCentralRequest,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/claims/{id}/approve-cancel',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public editAppointmentAt({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: UpdateDateRequest,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/claims/{id}/appointment',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PaginatedClaimDTO OK
     * @throws ApiError
     */
    public getAllClaim({
        shopId,
        search,
        sortBy = 'created_at',
        sort = 'desc',
        page = 1,
        limit = 10,
        type,
        modeType,
        status,
        appointment,
        startDate,
        endDate,
    }: {
        shopId: string,
        search?: string,
        sortBy?: string,
        sort?: string,
        page?: number,
        limit?: number,
        type?: 'SELF' | 'RECEIVE_CENTRAL' | 'SEND_CENTRAL',
        modeType?: 'NONE' | 'WAIT_SELECTION' | 'WAIT_APPROVAL' | 'APPROVED' | 'NOT_APPROVED',
        status?: 'NONE' | 'RECEIVE' | 'ORDER_SPARE' | 'RECEIVE_SPARE' | 'REPAIRING' | 'TESTING' | 'REPAIR_SUCCESS' | 'REPAIR_FAIL' | 'CANCEL',
        appointment?: 'NOW_APPOINTMENT' | 'BEFORE_APPOINTMENT_3DAYS' | 'BEFORE_APPOINTMENT_7DAYS' | 'AFTER_APPOINTMENT_ALL' | 'AFTER_APPOINTMENT_3DAYS' | 'AFTER_APPOINTMENT_7DAYS',
        startDate?: string,
        endDate?: string,
    }): CancelablePromise<PaginatedClaimDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/claims',
            query: {
                'shopId': shopId,
                'search': search,
                'sortBy': sortBy,
                'sort': sort,
                'page': page,
                'limit': limit,
                'type': type,
                'modeType': modeType,
                'status': status,
                'appointment': appointment,
                'startDate': startDate,
                'endDate': endDate,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public createClaim({
        requestBody,
    }: {
        requestBody: CreateClaimRequest,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/claims',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public sendClaimProduct({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: ClaimShippingRequest,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/claims/{id}/shipping',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public saveNote({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: CreateNoteRequest,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/claims/{id}/note',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public paidInvoice({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: CreateInvoiceRequest,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/claims/{id}/invoice',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public saveImage({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: CreateClaimImageRequest,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/claims/{id}/image',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public approveClaimCentral({
        shopId,
        id,
        requestBody,
    }: {
        shopId: string,
        id: string,
        requestBody: ApproveClaimCentralRequest,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/claims/{id}/approve',
            path: {
                'id': id,
            },
            query: {
                'shopId': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public claimProduct({
        formData,
    }: {
        formData?: {
            installmentId: string;
            reason: string;
            imei: string;
            serial: string;
            frontClaimImage: Blob;
            backClaimImage: Blob;
            topClaimImage: Blob;
            bottomClaimImage: Blob;
            leftClaimImage: Blob;
            rightClaimImage: Blob;
            imeiSerialImage: Blob;
            settingImage: Blob;
            testFaceImage: Blob;
            boxImeiAndSerialImage?: Blob;
            accessoriesImage: Blob;
        },
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/claims/product',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ClaimCentralDTO OK
     * @throws ApiError
     */
    public getCentralProcessStatus({
        receiverShopId,
        id,
    }: {
        receiverShopId: string,
        id: string,
    }): CancelablePromise<ClaimCentralDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/claims/{id}/process-status',
            path: {
                'id': id,
            },
            query: {
                'receiverShopId': receiverShopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns GetClaimCentralDetailResponse OK
     * @throws ApiError
     */
    public getClaimCentralDetail({
        shopId,
        id,
    }: {
        shopId: string,
        id: string,
    }): CancelablePromise<GetClaimCentralDetailResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/claims/{id}/central',
            path: {
                'id': id,
            },
            query: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ClaimCentralProcessDTO OK
     * @throws ApiError
     */
    public getCentralProcessStatusHistory({
        id,
        shopId,
    }: {
        id: string,
        shopId: string,
    }): CancelablePromise<Array<ClaimCentralProcessDTO>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/claims/{id}/central/process-status',
            path: {
                'id': id,
            },
            query: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns GetClaimNoResponse OK
     * @throws ApiError
     */
    public getNextClaimNo(): CancelablePromise<GetClaimNoResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/claims/suggest',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns GetClaimStatResponse OK
     * @throws ApiError
     */
    public getStatistics({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<GetClaimStatResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/claims/statistic',
            query: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PaginatedClaimStatementDTO OK
     * @throws ApiError
     */
    public getAllClaimStatement({
        shopId,
        search,
        sortBy = 'created_at',
        sort = 'desc',
        page = 1,
        limit = 10,
        type,
        startDate,
        endDate,
    }: {
        shopId: string,
        search?: string,
        sortBy?: string,
        sort?: string,
        page?: number,
        limit?: number,
        type?: 'SELF' | 'RECEIVE' | 'AVAILABLE',
        startDate?: string,
        endDate?: string,
    }): CancelablePromise<PaginatedClaimStatementDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/claims/statement',
            query: {
                'shopId': shopId,
                'search': search,
                'sortBy': sortBy,
                'sort': sort,
                'page': page,
                'limit': limit,
                'type': type,
                'startDate': startDate,
                'endDate': endDate,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ClaimProductHistoryResponse OK
     * @throws ApiError
     */
    public getClaimProductList({
        installmentPlanId,
    }: {
        installmentPlanId: string,
    }): CancelablePromise<ClaimProductHistoryResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/claims/product/{installmentPlanId}',
            path: {
                'installmentPlanId': installmentPlanId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ClaimProductDataResponse OK
     * @throws ApiError
     */
    public getClaimProduct({
        claimProductId,
    }: {
        claimProductId: string,
    }): CancelablePromise<ClaimProductDataResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/claims/product/transaction/{claimProductId}',
            path: {
                'claimProductId': claimProductId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns GetClaimDashboardResponse OK
     * @throws ApiError
     */
    public getDashboardStatistics({
        shopId,
        year,
    }: {
        shopId: string,
        year: number,
    }): CancelablePromise<Array<GetClaimDashboardResponse>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/claims/dashboard',
            query: {
                'shopId': shopId,
                'year': year,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns GetClaimDashboardStatResponse OK
     * @throws ApiError
     */
    public getDashboardStatistics1({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<GetClaimDashboardStatResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/claims/dashboard/statistic',
            query: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns number OK
     * @throws ApiError
     */
    public getCredit({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<number> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/claims/credit',
            query: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PaginatedGetAllClaimCentralResponse OK
     * @throws ApiError
     */
    public getAllClaimCentral({
        shopId,
        search,
        sortBy = 'created_at',
        sort = 'desc',
        page = 1,
        limit = 10,
        type,
        startDate,
        endDate,
    }: {
        shopId: string,
        search?: string,
        sortBy?: string,
        sort?: string,
        page?: number,
        limit?: number,
        type?: 'SELF' | 'RECEIVE' | 'AVAILABLE',
        startDate?: string,
        endDate?: string,
    }): CancelablePromise<PaginatedGetAllClaimCentralResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/claims/central',
            query: {
                'shopId': shopId,
                'search': search,
                'sortBy': sortBy,
                'sort': sort,
                'page': page,
                'limit': limit,
                'type': type,
                'startDate': startDate,
                'endDate': endDate,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns GetPublicClaimDetailResponse OK
     * @throws ApiError
     */
    public getPublicClaimDetail({
        claimNo,
    }: {
        claimNo: string,
    }): CancelablePromise<GetPublicClaimDetailResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/public/v2/claims/{claimNo}',
            path: {
                'claimNo': claimNo,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public deleteImage({
        id,
        documentRefId,
    }: {
        id: string,
        documentRefId: string,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v2/claims/{id}/image/{documentRefId}',
            path: {
                'id': id,
                'documentRefId': documentRefId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
